<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.619"
        height="20.61"
        viewBox="0 0 16.619 20.61"
    >
        <g id="File">
            <path
                id="Pfad_375"
                data-name="Pfad 375"
                d="M15.259,20.61H1.36A1.322,1.322,0,0,1,0,19.333V1.278A1.322,1.322,0,0,1,1.36,0H9.612a.826.826,0,0,1,.579.234L16.4,6.386a.727.727,0,0,1,.219.516V19.333a1.322,1.322,0,0,1-1.36,1.277M1.6,19.11H15.023V7.2L9.269,1.5H1.6Z"
                :class="fillClass + ' transition-fill'"
            />
            <path
                id="Pfad_376"
                data-name="Pfad 376"
                d="M15.3,7.832H9.6A1.45,1.45,0,0,1,8.115,6.425V.75h1.6V6.332H15.3Z"
                transform="translate(0.52)"
                :class="fillClass + ' transition-fill'"
            />
        </g>
        <g id="Arrow" transform="translate(6.491 15.559) rotate(-90)">
            <path
                id="Pfad_297"
                data-name="Pfad 297"
                d="M88.565,119.47l-2.72,3.085a.225.225,0,0,1-.345,0l-2.719-3.084a.283.283,0,0,1,.173-.473l5.438,0A.283.283,0,0,1,88.565,119.47Z"
                transform="translate(-82.71 -118.997)"
                :class="fillClass + ' transition-fill'"
            />
        </g>
    </svg>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "FileVideoIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
    },
});
</script>
